export function resolveFleetBaseDivisions(
  groups: Group[] | null | undefined,
  groupId: string,
  selectedDivisionIds: string[] | undefined,
  divisionIdsCsv?: string | null,
): string[] {
  const fromCsv =
    divisionIdsCsv
      ?.split(',')
      .map(id => id.trim())
      .filter(Boolean) ?? [];

  const explicit =
    selectedDivisionIds && selectedDivisionIds.length > 0
      ? selectedDivisionIds
      : fromCsv;

  if (explicit.length > 0) return explicit;

  const selectedGroup = groups?.find(group => group.groupId === groupId);
  return (
    selectedGroup?.groupDivision
      .map(division => division.divisionId)
      .filter(Boolean) || []
  );
}
